<template>
  <div>
    <tableTitle>转户基本详情</tableTitle>
    <Form ref="formValidate" :label-width="125" style="margin:30px" inline>
      <FormItem label="转户ID">
        <Input :value="deliverInfo.id" style="width: 150px;" readonly />
      </FormItem>
      <br>
      <FormItem label="转出方">
        <dict-select :value="deliverInfo.deliverOutLeaseeId" namespace="bizObjects" id="member" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <FormItem label="接收方">
        <dict-select :value="deliverInfo.deliverInLeaseeId" namespace="bizObjects" id="member" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <br>
      <FormItem label="标的物小类">
        <dict-select :value="deliverInfo.targetType" namespace="target" id="type" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <FormItem label="转户数量">
        <Input v-model="deliverInfo.amount" style="width: 150px;" disabled />
      </FormItem>
      <br>
      <FormItem label="转户协议">
        <Input v-model="deliverInfo.deliverAgreementCode" style="width: 150px;" disabled />
      </FormItem>
      <FormItem label="状态">
        <dict-select :value="deliverInfo.status" namespace="ENUM_MID-OPERATE-LEASE" id="deliver.DeliverStatus" :exclusion="[]" style="width: 150px;" disabled />
      </FormItem>
      <br>
      <FormItem label="转出时间">
        <DatePicker :value="deliverInfo.deliverOutDate" type="date" style="width: 200px" disabled></DatePicker>
      </FormItem>
      <br />
      <FormItem label="备注信息">
        <Input v-model="deliverInfo.remark" type="textarea" style="width:490px" disabled />
      </FormItem>
    </Form>

    <tableTitle>转户合约列表</tableTitle>
    <Table :columns="cols" :data="contractList" style="width:400px;margin:20px"></Table>

    <tableTitle>附件列表</tableTitle>
    <a v-for="(item,index) in imgList" :key="index" style="padding-left:20px" @click="onDownloadFile(pltUtil.downloadUrl()+item.id)" title="点击下载该附件！">{{item.originFileName}}</a>

    <div style="text-align:center;width:700px;margin:30px">
      <Button type="warning" style="margin-left:20px" @click="back">返回</Button>
    </div>
    <preview-image ref="previewImageRef" />
  </div>
</template>
<script>
import dictSelect from "@/components/select/dict-select.vue";
import bizSelect from "@/components/select/biz-select.vue";
import tableTitle from "@/components/tableTitle/tableTitle.vue";
export default {
  components: {
    dictSelect,
    bizSelect,
    tableTitle,
  },
  props: ["deliverInfo"],
  data() {
    return {
      contractList: [],
      cols: [
        { title: "合约号", key: "contractNo" },
        { title: "数量", key: "amount" },
      ],
      imgList: [],
    };
  },
  mounted() {
    if (this.deliverInfo.id) {
      this.queryContractList();
    }
    if (this.deliverInfo.documentId) {
      this.queryImgList();
    }
  },
  methods: {
    onDownloadFile(url) {
      var tempwindow = window.open("_blank");
      tempwindow.location = `${url}&disposition=inline`;
    },
    queryImgList() {
      let params = {
        url: "http://MID-TECH-IMAGE/messageService/documentService/queryDocument",
        body: {
          id: this.deliverInfo.documentId,
        },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.imgList = rs.files;
        }
      });
    },
    queryContractList() {
      let params = {
        url: "http://MID-OPERATE-LEASE/messageService/deliverService/queryContractListByDeliverId",
        body: {
          deliverId: this.deliverInfo.id,
        },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.contractList = rs;
        }
      });
    },
    back() {
      this.$emit("on-finish", {});
    },
  },
};
</script>